export default "__VITE_ASSET__CqhDoKP4__"